module.exports = __webpack_public_path__ + "static/media/green-background-3x.137c1538.jpg";